import React, { useState, useEffect } from 'react';
import { withRouter, useLocation } from "react-router-dom";
import { Typography, message, Carousel, Button, Form, Row, Col, Input, Tooltip, Card, Spin } from "antd";
import { platformApi } from '../../api'
import {
    LeftOutlined,
    LoadingOutlined
} from '@ant-design/icons';
import './style.less'
import Moment from 'moment'
import CustomerInfo from '../FollowUp/CustomerInfo';
import ActivityLog from '../FollowUp/ActivityLog';
import VehicleInfo from './VehicleInfo';

const ServiceFollowUp = (props) => {
    const location = useLocation();

    const { Title, Text } = Typography;
    const [customerId, setCustomerId] = useState(null);
    const [customerIds, setCustomerIds] = useState(null);
    const [customerPhone, setCustomerPhone] = useState(null);
    const [allCustomers, setCustomers] = useState([])
    const [customerDetails, setCustomerDetails] = useState(null);
    const [mergedVehicles, setMergedVehicles] = useState([]);
    const [mergedPurchasedVehicle, setMergedPurchasedVehicle] = useState([]);
    const [activities, setActivities] = useState([]);
    const [followUpDate, setFollowUpDate] = useState();
    const [loading, setLoading] = useState(true);
    const [refreshing, setRefreshing] = useState(false);

    // Helper function to get start and end of month from a date
    const getMonthRange = (date) => {
        if (!date) return { fromDate: null, toDate: null };
        
        const momentDate = Moment(date);
        const fromDate = momentDate.clone().startOf('month').format('YYYY-MM-DD');
        const toDate = momentDate.clone().endOf('month').format('YYYY-MM-DD');
        
        // Convert to ISO string format with timezone offset (18:30:00.000Z for IST)
        const fromDateISO = `${fromDate}T18:30:00.000Z`;
        const toDateISO = `${toDate}T18:30:00.000Z`;
        
        return { fromDate: fromDateISO, toDate: toDateISO };
    };

    useEffect(() => {
        settingDetails();
        return () => {
            clearingState();
        }
    }, [location])

    const settingDetails = () => {
        const { phoneNo, fupDate } = props.match.params
        setCustomerPhone(phoneNo)
        setFollowUpDate(fupDate);
        setLoading(true);
        getCustomersByPhone(phoneNo)
    }

    const clearingState = () => {
        setActivities([])
        setMergedVehicles([])
        setCustomers([])
        setCustomerDetails(null)
    }

    const getCustomersByPhone = (phoneNo = customerPhone) => {
        platformApi.get(`/api/customer/phoneNo/${phoneNo}`)
            .then(res => {
                const { data: { response: { data: { customers } } } } = res;
                setCustomers(customers)
                if (customers.length) {
                    let allCustomerIDS = customers.map(customer => customer.id || customer.customerId)
                    setCustomerIds(allCustomerIDS)
                    setCustomerId(customers[0].id || customers[0].customerId);
                    getCustomerInfo(customers[0].id || customers[0].customerId)
                    getMergedInfo(allCustomerIDS)
                    getActivityByCustomer(allCustomerIDS)
                }
                setLoading(false);
                setRefreshing(false);
            })
            .catch(err => {
                console.error("Error fetching customers:", err);
                setLoading(false);
                setRefreshing(false);
            })
    }
    
    const getMergedInfo = (ids = customerIds) => {
    platformApi.post('/api/vehicle/customerVehicle', {
        customer: ids
    }).then(res => {
        const { data: { response: { data } } } = res;
        if (!data || !Array.isArray(data)) {
            setMergedVehicles([]);
            return;
        }

        const fupDate = props.match?.params?.fupDate ? Moment(props.match.params.fupDate).format("YYYY-MM-DD") : null;
        let selectedVehicle = null;

        // 🔹 1. Priority: if registerNo is passed in location.state
        if (location?.state?.registerNo) {
            selectedVehicle = data.find(vehicle => vehicle.registerNo === location.state.registerNo);
        }

        // 🔹 2. If no registerNo match, check if fupDate matches any serviceReminder
        if (!selectedVehicle && fupDate) {
            selectedVehicle = data.find(vehicle =>
                vehicle.serviceReminders?.some(rem =>
                    Moment(rem.serviceDate).format("YYYY-MM-DD") === fupDate
                )
            );
        }

        // 🔹 3. Fallback: pick first record
        if (!selectedVehicle && data.length > 0) {
            selectedVehicle = data[0];
        }

        setMergedVehicles(selectedVehicle ? [selectedVehicle] : []);
    }).catch(err => {
        console.error("Error fetching vehicle info:", err);
        setMergedVehicles([]);
    });
};


    const updateCustomerData = (customer) => {
        platformApi
            .put(`/api/customer/${customer.id}`, customer)
            .then((result) => {
                const { data } = result;
                if (data.code === 200) {
                    const { response } = data;
                    if (response.code === 200) {
                        getCustomerInfo();
                        message.success("Customer updated successfully", 2);
                    } else {
                        message.error("Unable to update customer", 2);
                    }
                } else if (data.code === 500 && data.err.code === 500) {
                    message.error("Customer name already exists", 2);
                } else {
                    message.error("Unable to update customer", 2);
                }
            })
            .catch((error) => {
                message.error("Unable to update customer", 2);
                console.error("Error on customer : ", error);
            });
    };

    const getCustomerInfo = (custId = customerId) => {
        let customer = custId
        if (customer) {
            platformApi.get(`/api/customer/${customer}`).then(result => {
                const { data } = result.data.response;
                setCustomerDetails(data);
            }).catch(err => {
                console.error("Error fetching customer info:", err);
                setCustomerDetails(null);
            })
        }
    }

    const getActivityByCustomer = (ids = customerIds, limit = 15, offset = 0) => {
        platformApi.post('/api/activity/customers', {
            limit,
            offset,
            ids
        }).then(res => {
            const { data: { response: { data } } } = res
            const temp = data.filter(item => {
                return item.interactionType === 'Service Followup Call' || item.interactionType === 'Service Followup Message' || item.activityType === 'Service'
            })
            setActivities(temp)
        }).catch(err => {
            console.error("Error fetching activities:", err);
            message.error("Unable to get Activities");
            setActivities([]);
        })
    }
    
    const changeFollowUp = (next = false) => {
        if (!mergedVehicles[0]?.id) {
            message.error("No vehicle data available");
            return;
        }
        
        if (!followUpDate) {
            message.error("No follow-up date available");
            return;
        }
        
        setRefreshing(true);
        
        // Get month range from followUpDate
        const { fromDate, toDate } = getMonthRange(followUpDate);
        console.log("Month range:", { followUpDate, fromDate, toDate });
        
        const payload = {
            fupDateTime: followUpDate,
            next,
            vehicle: mergedVehicles[0]?.id,
            status: location?.state?.tab || 'PENDING',
            fromDate: fromDate,
            toDate: toDate
        };
        
        console.log("Sending payload:", payload);
        
        platformApi.post("/api/vehicle/scheduled", payload).then((res) => {
            const { data: { response } } = res;
            console.log("API Response:", response);
            
            if (response.code === 200 && response.data && response.data.length > 0) {
                const vehicleInfo = response.data[0];
                
                // Get phone number
                let phoneNo = null;
                if (vehicleInfo.customer && vehicleInfo.customer.length > 0) {
                    const primaryContact = vehicleInfo.customer[0].customer?.contacts?.find(contact => 
                        contact.type === "Primary" || contact.valid === true
                    );
                    phoneNo = primaryContact?.phone || 
                             (vehicleInfo.customer[0].customer?.contacts?.[0]?.phone);
                }
                
                // Get service date
                let serviceDate = followUpDate;
                if (vehicleInfo.service && vehicleInfo.service.length > 0 && vehicleInfo.service[0].serviceDate) {
                    serviceDate = vehicleInfo.service[0].serviceDate;
                }
                
                if (phoneNo && serviceDate) {
                    // Use history.replace instead of push to avoid back button issues
                    props.history.replace(`/autoadmin/service-followups/${phoneNo}/fupdate/${serviceDate}`, {
                        tab: location?.state?.tab || 'PENDING'
                    });
                    message.success("FollowUp Fetched!");
                } else {
                    message.error("Missing phone number or service date in response");
                    setRefreshing(false);
                }
            } else {
                const msg = next ? "No Next FollowUp Exist" : "No Previous FollowUp Exist";
                message.info(msg);
                setRefreshing(false);
            }
        }).catch(err => {
            console.error("Error changing followup:", err);
            message.error("Error fetching followup data");
            setRefreshing(false);
        });
    }
    
    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                <Spin indicator={<LoadingOutlined style={{ fontSize: 48 }} spin />} />
            </div>
        );
    }

    return (
        <div className="follow-ups">
            <Title style={{ width: "60%" }} level={4}>
                <Tooltip placement="topLeft" title={"Back"}>
                    <Button
                        style={{ margin: "0 20px" }}
                        onClick={() => props.history.push('/autoadmin/service-followups')}
                        disabled={refreshing}
                    >
                        <LeftOutlined />
                    </Button>
                </Tooltip>
                Service Follow-Ups
                {refreshing && <Spin size="small" style={{ marginLeft: 20 }} />}
            </Title>
            
            <Row type='flex' justify='space-between' gutter={[16, 16]}>
                <Col span={24}>
                    <Row type='flex' justify='space-between'>
                        <Col>
                            <Button
                                style={{ margin: "0 20px" }}
                                onClick={() => changeFollowUp()}
                                disabled={refreshing}
                            >
                                Previous
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                style={{ margin: "0 20px" }}
                                onClick={() => changeFollowUp(true)}
                                disabled={refreshing}
                            >
                                Next
                            </Button>
                        </Col>
                    </Row>
                </Col>
                
                {mergedVehicles.length > 0 ? (
                    <Col span={24}>
                        <Card>
                            <Row type='flex' justify='space-between' gutter={[16, 16]}>
                                <Col span={8}>
                                    <Carousel
                                        initialSlide={0}
                                        beforeChange={(from, to) => {
                                            if (allCustomers.length) {
                                                setCustomerId(allCustomers[to]?.id || allCustomers[to]?.customerId)
                                                getCustomerInfo(allCustomers[to]?.id || allCustomers[to]?.customerId)
                                            }
                                        }}
                                    >
                                        {customerDetails && allCustomers.map((customer, index) => (
                                            <CustomerInfo
                                                key={index}
                                                updateCustomerData={updateCustomerData}
                                                customer={customerDetails}
                                                enquiryType={"-"}
                                                setCustomer={setCustomerDetails}
                                            />
                                        ))}
                                    </Carousel>
                                </Col>
                                <Col span={16}>
                                    {customerDetails && <VehicleInfo
                                        customerId={customerId}
                                        getCustomerInfo={getCustomerInfo}
                                        getActivityByCustomer={getActivityByCustomer}
                                        dataSource={mergedVehicles}
                                        customerDetail={customerDetails}
                                        actionStatus={true}
                                        activityType={"Service"}
                                        onFollowUpSelect={(createdAt) => setFollowUpDate(createdAt)}
                                        followUpDate={followUpDate}
                                    />}
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                ) : (
                    <Col span={24}>
                        <Card>
                            <div style={{ textAlign: 'center', padding: '40px' }}>
                                <Title level={4}>No vehicle data available</Title>
                                <Text>Unable to load vehicle information for this customer.</Text>
                            </div>
                        </Card>
                    </Col>
                )}

                <Col span={24}>
                    <ActivityLog
                        customerId={customerId}
                        dataSource={activities}
                        setDataSource={setActivities}
                        getActivityByCustomer={getActivityByCustomer}
                    />
                </Col>
            </Row>
        </div>
    )
}
export default withRouter(ServiceFollowUp);